import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { GetStartedForm } from '../components/GetStartedForm';
import { ArrowRight, Building2, Briefcase, HeartPulse, BarChart3, Truck, Landmark, Hotel } from 'lucide-react';
export function SolutionsPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const navigate = useNavigate();
  // Handle smooth navigation to new pages
  const handleNavigation = (e, path) => {
    e.preventDefault();
    // If it's a hash link on the same page, use native smooth scroll
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      return;
    }
    // For navigation to different pages
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // After smooth scroll animation completes, navigate to the new page
    setTimeout(() => {
      navigate(path);
    }, 500); // Adjust timing based on scroll animation duration
  };
  return <div className="flex flex-col min-h-screen w-full" data-id="element-1541">
      <Header data-id="element-1542" />
      <main className="flex-grow" data-id="element-1543">
        {/* Hero Section */}
        <div className="bg-black text-white py-16 md:py-24" data-id="element-1544">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1545">
            <div className="text-center" data-id="element-1546">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1547">
                Solutions for Every Industry
              </h1>
              <p className="text-xl md:text-2xl max-w-3xl mx-auto text-gray-300" data-id="element-1548">
                Discover how Agentter.ai's intelligent agents can transform
                workflows across different sectors.
              </p>
            </div>
          </div>
        </div>
        {/* Industries Grid */}
        <div className="py-16 md:py-24 bg-white" data-id="element-1549">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1550">
            <h2 className="text-3xl font-bold text-center mb-12" data-id="element-1551">
              Industries We Serve
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1552">
              <IndustryCard icon={<Building2 size={24} data-id="element-1554" />} title="Real Estate" description="Automate property listings, schedule viewings, and respond to tenant inquiries 24/7." link="/solutions/real-estate" handleNavigation={handleNavigation} data-id="element-1553" />
              <IndustryCard icon={<HeartPulse size={24} data-id="element-1556" />} title="Healthcare" description="Manage patient appointments, insurance verification, and routine follow-ups." link="/solutions/healthcare" handleNavigation={handleNavigation} data-id="element-1555" />
              <IndustryCard icon={<BarChart3 size={24} data-id="element-1558" />} title="Finance" description="Process transactions, generate reports, and monitor for unusual activity." link="/solutions/finance" handleNavigation={handleNavigation} data-id="element-1557" />
              <IndustryCard icon={<Truck size={24} data-id="element-1560" />} title="Freight Companies" description="Track shipments, manage inventory, and optimize delivery routes." link="/solutions/freight" handleNavigation={handleNavigation} data-id="element-1559" />
              <IndustryCard icon={<Landmark size={24} data-id="element-1562" />} title="Shipping" description="Manage vessel operations, automate documentation, and enhance supply chain visibility." link="/solutions/shipping" handleNavigation={handleNavigation} data-id="element-1561" />
              <IndustryCard icon={<Building2 size={24} data-id="element-1564" />} title="Construction" description="Streamline project management, optimize resource allocation, and enhance safety compliance." link="/solutions/construction" handleNavigation={handleNavigation} data-id="element-1563" />
              <IndustryCard icon={<Hotel size={24} data-id="element-1566" />} title="Hospitality" description="Enhance guest experiences, automate reservations, and optimize housekeeping operations." link="/solutions/hospitality" handleNavigation={handleNavigation} data-id="element-1565" />
              <IndustryCard icon={<Briefcase size={24} data-id="element-1568" />} title="Professional Services" description="Streamline client onboarding, document processing, and appointment scheduling." link="#" handleNavigation={handleNavigation} data-id="element-1567" />
            </div>
          </div>
        </div>
        {/* CTA Section */}
        <div className="bg-black text-white py-16" data-id="element-1569">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1570">
            <h2 className="text-3xl font-bold mb-6" data-id="element-1571">
              Ready to transform your industry?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto" data-id="element-1572">
              Schedule a consultation with our solutions team to discover how
              Agentter.ai can be tailored to your specific needs.
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-1573">
              <button onClick={() => setIsFormOpen(true)} className="bg-white text-black px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-1574">
                Book a Demo
              </button>
              <button onClick={() => setIsFormOpen(true)} className="border border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-900 transition-colors" data-id="element-1575">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1576" />
      {/* Get Started Form */}
      <GetStartedForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-1577" />
    </div>;
}
function IndustryCard({
  icon,
  title,
  description,
  link,
  handleNavigation
}) {
  return <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 hover:shadow-md transition-shadow" data-id="element-1578">
      <div className="bg-black text-white p-3 rounded-lg inline-block mb-4" data-id="element-1579">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-2" data-id="element-1580">{title}</h3>
      <p className="text-gray-600 mb-4" data-id="element-1581">{description}</p>
      <a href={link} className="inline-flex items-center text-black font-medium hover:underline" onClick={e => handleNavigation(e, link)} data-id="element-1582">
        Learn more <ArrowRight size={16} className="ml-2" data-id="element-1583" />
      </a>
    </div>;
}